import { Flex, List } from 'antd';
import ActionHeader from '../../../../components/actionHeader';
import { StyledListItem } from '../../../../styles/listItem';
import { ListContainer } from './styles';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../../store';
import {
  selectIsFetchingMachine,
  selectMachine,
} from '../../../../slices/machines';
import { useParams } from 'react-router';
import {
  fetchCauses,
  selectCausesForMachine,
  selectIsFetchingCauses,
  setCauses,
} from '../../../../slices/causes';
import CauseCard from '../../../../components/causeCard';
import { useTranslation } from 'react-i18next';

const MachineCauses = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const machine = useSelector(selectMachine);
  const isFetchingCauses = useSelector(selectIsFetchingCauses);
  const isFetchingMachine = useSelector(selectIsFetchingMachine);
  const causes = useSelector(selectCausesForMachine);

  const isFetching = isFetchingCauses || isFetchingMachine;

  const handleSearch = (searchText?: string) => {
    if (!isFetchingCauses) {
      dispatch(
        fetchCauses({
          templateID: machine?.templateID,
          params: { search: searchText },
        })
      );
    }
  };

  useEffect(() => {
    if (String(machine?.machineID) !== id) {
      dispatch(setCauses([]));
    }
    if (machine && machine.name) {
      dispatch(fetchCauses({ templateID: machine?.templateID }));
    }
  }, [machine]);
  return (
    <Flex vertical flex={1} gap={8} style={{ height: '100%' }}>
      <ActionHeader
        title={t('cause')}
        isSecondaryTitle
        showBorder={false}
        showSearch
        onSearch={handleSearch}
      />
      <Flex flex={1} style={{ overflowY: 'auto' }}>
        <ListContainer>
          <List
            dataSource={causes}
            loading={isFetching}
            renderItem={(item) => (
              <StyledListItem>
                <CauseCard cause={item} showEdit={false} showDelete={false} />
              </StyledListItem>
            )}
          ></List>
        </ListContainer>
      </Flex>
    </Flex>
  );
};

export default MachineCauses;
